import { Parallax } from 'react-parallax';
import { getAssetPath, getSrcSet } from 'utils';
import styles from "./ParallaxBlock.module.css";
import classNames from 'classnames';
import React, { FC, useLayoutEffect } from "react";
import $ from "jquery";
import { useDeviceClassification } from 'utils';


 const _ParrallaxContainer = ({
    children,
    imgSrc = "",
    imgAlt = "",
    className = "",
    height,
    type,
}) => {

    const { isDesktop } = useDeviceClassification();

    useLayoutEffect(() => {
        const parralaxContainerHeight = $(`.${className}`).height();
        const textBoxHeight = $(`.${className} .textBox`).height();

        const containerGrow = textBoxHeight > parralaxContainerHeight;
        const contentNeedsPadding = (parralaxContainerHeight - textBoxHeight) < 150;

        if(containerGrow) $(`.${className}`).height(textBoxHeight + 200)
        if(contentNeedsPadding) $(`.${className}`).height(textBoxHeight + 200)
    }, [children]);

    return (
        <Parallax
            bgImageSrcSet={getSrcSet(getAssetPath(imgSrc), [150, 300, 480, 768, 1024, 2048])}
            className={classNames(styles.parralaxBlock, type, className)}
            style={{ height: height ? height : '1px' }}
            bgImage={getAssetPath(imgSrc)}
            bgImageAlt={imgAlt}
            strength={70}>
            {children}
        </Parallax>
    )

};

export const ParrallaxContainer = React.memo(_ParrallaxContainer)

